import React from 'react';
import { usePortletStore } from '../../App';

function SensePortalComponent(): React.JSX.Element {
  const portalName = usePortletStore(state => state.configuration.portalName);

  return (
    <section>
      <h1 className="portalname">{portalName}</h1>
    </section>
  );
}

export const SensePortal = SensePortalComponent;
